import { Expose } from 'class-transformer';

export class SkillDto {
  @Expose()
  uuid: string;

  @Expose()
  title: string;

  @Expose()
  createdAt: string;

  @Expose()
  updatedAt: string;
}
